import { AdminKeysSecretsEnvironmentCredentials } from "../../models/admin-keys-secrets.models";
import AdminKeysSecretsEnvironmentRow from "./AdminKeysSecretsEnvironmentRow";

type Props = {
  environments: AdminKeysSecretsEnvironmentCredentials[];
};

const AdminKeysSecretsEnvironmentTable = ({ environments }: Props) => {
  return (
    <section
      data-test="admin-keys-secrets-environments"
      className="min-w-0 overflow-hidden border border-[#D7E2DE] bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
    >
      <div className="overflow-x-auto">
        <table className="min-w-full table-fixed text-left">
          <thead className="border-b border-[#D7E2DE] bg-[#F8FBFA] text-[12px] font-semibold uppercase text-[#4A5655] dark:border-gray-700 dark:bg-teal-900 dark:text-gray-400">
            <tr>
              <th scope="col" className="w-32 px-4 py-2">
                Env
              </th>
              <th scope="col" className="min-w-[220px] px-4 py-2">
                IAM user
              </th>
              <th scope="col" className="min-w-[220px] px-4 py-2">
                Access Key
              </th>
              <th scope="col" className="min-w-[300px] px-4 py-2">
                Secret Key
              </th>
              <th scope="col" className="w-40 px-4 py-2">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {environments.map((environmentCredentials) => (
              <AdminKeysSecretsEnvironmentRow
                key={environmentCredentials.environment}
                environmentCredentials={environmentCredentials}
              />
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default AdminKeysSecretsEnvironmentTable;
